module.exports = __webpack_public_path__ + "img/blue_077.34905c72.png";